import { render } from "./SelectedOrderChips.vue?vue&type=template&id=a821f58c&scoped=true&ts=true"
import script from "./SelectedOrderChips.vue?vue&type=script&lang=ts"
export * from "./SelectedOrderChips.vue?vue&type=script&lang=ts"

import "./SelectedOrderChips.vue?vue&type=style&index=0&id=a821f58c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a821f58c"]])

export default __exports__